// import { Link } from 'react-router-dom';
// import { Mail } from 'lucide-react';
// import Disclaimer from '../disclaimer'
import { PoweredByAida } from '@/component/ui/powered-by-aida'

export type HomeProps = {
  userName: string;
};

export const Home = (props: HomeProps) => {
  const { userName } = props;

  return (
    <div className='w-full min-h-screen bg-white pt-5 md:pt-8 pb-8 px-4 md:px-6'>
      <div className='w-full max-w-[384px] md:max-w-[1030px] mx-auto flex flex-col'>
        <PoweredByAida />
        <h1 className='mt-3 md:mt-4 text-6xl font-bold'>Hi {userName}!</h1>
        <div className='flex items-center justify-between mb-6 mt-6'>
          <h1 className='text-3xl font-bold'>Welcome to Janoos</h1>
        </div>
      {/* Intro paragraph */}
      <p className='text-gray-600 mb-6'>
        Welcome to Janoos—a secure, flexible environment designed to strengthen and simplify teaching. Janoos provides ready-made AI tools for curriculum design, assessment creation, feedback, and learning analytics, all grounded in validated educational research. Its purpose is to reduce administrative load, expand pedagogical options, and enhance student learning at scale. Janoos empowers you to innovate with confidence while ensuring compliance and quality assurance are seamlessly built in.
      </p>

      {/* Disclaimer */}
      {/* <Disclaimer /> */}

      {/* <div className='flex items-center justify-between mb-6'>
        <h2 className='text-2xl font-bold'>Latest activities</h2>
      </div>
      <hr/>
      <div className="flex pt-4">
        <h3 className='text-1xl font-bold'>Latest resources</h3>
      </div> */}
      {/* <ResourceFile /> */}
      </div>
    </div>
  )
}
